webpackJsonp([0],[
/* 0 */,
/* 1 */,
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var jm = {
    getUrlString: function getUrlString(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        if (r != null) return decodeURIComponent(r[2]);
        return null;
    },
    getCookie: function getCookie(name) {
        var arr,
            reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
        if (arr = document.cookie.match(reg)) return decodeURIComponent(arr[2]);else return null;
    }
};

/* harmony default export */ __webpack_exports__["a"] = (jm);

/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function toThousands(num) {
    var num = (num || 0).toString(),
        result = '';
    while (num.length > 3) {
        result = ',' + num.slice(-3) + result;
        num = num.slice(0, num.length - 3);
    }
    if (num) {
        result = num + result;
    }
    return result;
};

/* harmony default export */ __webpack_exports__["a"] = (toThousands);

/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function computeRem(baseWidth, baseRem) {
    var winWidth = document.documentElement.clientWidth;
    if (winWidth <= 320) winWidth = 320;
    if (winWidth >= baseWidth) winWidth = baseWidth;
    var targetRem = winWidth / (baseWidth / 2) * baseRem;
    document.documentElement.style.fontSize = targetRem + "px";
}

var rem = {
    useRem: function useRem(baseWidth, baseRem) {
        computeRem(baseWidth, baseRem);
        window.addEventListener("resize", function () {
            computeRem(baseWidth, baseRem);
        });
    }
};
/* harmony default export */ __webpack_exports__["a"] = (rem);

/***/ }),
/* 5 */,
/* 6 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(13)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(9),
  /* template */
  __webpack_require__(22),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 7 */,
/* 8 */,
/* 9 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Gold_head_vue__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Gold_head_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_Gold_head_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LendMoney_vue__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_LendMoney_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_LendMoney_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tools_jm__ = __webpack_require__(2);






/* harmony default export */ __webpack_exports__["default"] = ({
    data: function data() {
        return {
            ajaxLoaded: false,
            ajaxError: false,
            userData: {}
        };
    },
    beforeCreate: function beforeCreate() {
        var self = this;
        var sid = __WEBPACK_IMPORTED_MODULE_2__tools_jm__["a" /* default */].getCookie("sid") || __WEBPACK_IMPORTED_MODULE_2__tools_jm__["a" /* default */].getUrlString("sid");
        $.ajax({
            url: "//ms.jr.jd.com/gw/generic/base/h5/m/getBorrowMoneyMess",
            data: { sid: sid },
            xhrFields: {
                withCredentials: true
            },
            success: function success(data) {
                var data = data.resultData;
                if (data) {
                    self.ajaxLoaded = true;
                    self.userData = {
                        goldData: {
                            ajaxError: false,
                            isOpenJt: data.isOpenJt,
                            isLogin: data.isLogin,
                            availableAssets: data.availableAssets
                        },
                        bankData: {
                            isLogin: data.isLogin,
                            lendmoneyList: data.lendmoneyList
                        }
                    };
                } else {
                    self.ajaxLoaded = false;
                    self.ajaxError = true;
                    self.userData = {
                        goldData: {
                            ajaxError: true,
                            isOpenJt: false,
                            isLogin: false
                        }
                    };
                }
            }
        });
    },
    components: { goldHead: __WEBPACK_IMPORTED_MODULE_0__components_Gold_head_vue___default.a, lendMoney: __WEBPACK_IMPORTED_MODULE_1__components_LendMoney_vue___default.a }
});

/***/ }),
/* 10 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_toThousands__ = __webpack_require__(3);




var getGoldStates = function getGoldStates(goldData) {
    if (goldData.ajaxError) {
        return {
            subTitle: "最高可借",
            slogenText: "啊哦，系统开小差了~",
            slogenSubText: "请稍后再试",
            btnText: "点击重试",
            btnHref: window.location.href
        };
    }
    if (goldData.isLogin == false) {
        _hmt.push(['_trackEvent', 'jieqian', 'ajax', 'show']);
        return {
            subTitle: "最高可借",
            slogenText: "现金借款 · 随借随还",
            slogenSubText: "支持借款到信用卡，方便还信用卡",
            btnText: "立即登录",
            btnHref: "//passport.m.jd.com/user/login.action?v=1&returnurl=" + encodeURIComponent(window.location.href)
        };
    }
    if (!goldData.isOpenJt) {
        _hmt.push(['_trackEvent', 'jieqian', 'ajax', 'show']);
        return {
            subTitle: "最高可借",
            slogenText: "现金借款 · 随借随还",
            slogenSubText: "支持借款到信用卡，方便还信用卡",
            btnText: "开通京东金条借钱",
            btnHref: "https://ms.jr.jd.com/jrpmobile/btbullion/bullion/jinTiaoIndex?sysCode=s2&sourceLink=c2"
        };
    }
    if (goldData.isOpenJt) {
        return {
            subTitle: "当前可借金额",
            slogenText: "日利率低至 0.025%",
            slogenSubText: "1000元借1天，利息低至0.25元",
            btnText: "立即借款",
            btnHref: "https://ms.jr.jd.com/jrpmobile/btbullion/bullion/jinTiaoIndex?sysCode=s2&sourceLink=c2"
        };
    }
};
/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'gold_head',
    props: {
        goldData: {
            type: Object,
            default: function _default() {
                return {
                    isOpenJt: false,
                    isLogin: false,
                    availableAssets: 300000
                };
            }
        }
    },
    data: function data() {
        return {};
    },
    computed: {
        goldAmount: function goldAmount() {
            var goldNum = 0;
            if (this.goldData.isLogin && this.goldData.isOpenJt) {
                goldNum = this.goldData.availableAssets;
            } else {
                goldNum = 300000;
            }
            return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__tools_toThousands__["a" /* default */])(goldNum);
        },
        goldStates: function goldStates() {
            var result = getGoldStates(this.goldData);
            return result;
        }
    }
});

/***/ }),
/* 11 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__tools_toThousands__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__tools_jm__ = __webpack_require__(2);





/* harmony default export */ __webpack_exports__["default"] = ({
    name: 'lendMoney',
    props: {
        bankData: {
            type: Object,
            default: function _default() {
                return {
                    isLogin: false,
                    lendmoneyList: []
                };
            }
        }
    },
    data: function data() {
        return {
            showList: true,
            showDefaultLength: 2,
            showAll: false
        };
    },
    computed: {
        items: function items() {
            var lendMoneyList = this.bankData.lendmoneyList;
            if (lendMoneyList) {
                var reg = new RegExp("id=([^&]*)(&|$)", "i");
                for (var i = 0; i < lendMoneyList.length; i++) {
                    var id = lendMoneyList[i].url.match(reg);
                    lendMoneyList[i].clstag = "pageclick|keycount|lendcard2017|" + id[1] + "|url";
                }
            }
            return lendMoneyList;
        },
        itemLength: function itemLength() {
            if (this.bankData.lendmoneyList) {
                return this.bankData.lendmoneyList.length;
            } else {
                this.showList = false;
                return 0;
            }
        }
    },
    methods: {
        getBankUrl: function getBankUrl(url) {
            if (this.bankData.isLogin) {
                return url;
            } else {
                var _url = "//passport.m.jd.com/user/login.action?v=1&returnurl=" + encodeURIComponent(window.location.href);
                return _url;
            }
        },
        changeAll: function changeAll(event) {
            this.showAll = !this.showAll;
        },
        replaceZh: function replaceZh(string) {
            return string.replace("元", "");
        }
    }
});

/***/ }),
/* 12 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_webpack_zepto__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_webpack_zepto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_webpack_zepto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_fastclick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_fastclick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tools_rem__ = __webpack_require__(4);







__WEBPACK_IMPORTED_MODULE_4__tools_rem__["a" /* default */].useRem(750, 100);

__WEBPACK_IMPORTED_MODULE_2_webpack_zepto___default.a.ajaxSettings.crossDomain = true;
__WEBPACK_IMPORTED_MODULE_3_fastclick___default.a.attach(document.body);

__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
    el: '#app',
    template: '<App/>',
    components: {
        App: __WEBPACK_IMPORTED_MODULE_1__App___default.a
    }
});

/***/ }),
/* 13 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 14 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 15 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/gold-logo.2340fdf.png";

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(15)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(10),
  /* template */
  __webpack_require__(24),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(14)

var Component = __webpack_require__(0)(
  /* script */
  __webpack_require__(11),
  /* template */
  __webpack_require__(23),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 22 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.ajaxLoaded) ? _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('goldHead', {
    attrs: {
      "goldData": _vm.userData.goldData
    }
  }), _vm._v(" "), _c('lendMoney', {
    attrs: {
      "bankData": _vm.userData.bankData
    }
  })], 1) : (_vm.ajaxError) ? _c('div', {
    staticClass: "error"
  }, [_c('goldHead', {
    attrs: {
      "goldData": _vm.userData.goldData
    }
  })], 1) : _vm._e()
},staticRenderFns: []}

/***/ }),
/* 23 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showList) ? _c('div', {
    staticClass: "lendMoney-wrap"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "lendMoney-list"
  }, _vm._l((_vm.items), function(item, index) {
    return (index < (_vm.showAll ? _vm.itemLength : _vm.showDefaultLength)) ? _c('li', {
      staticClass: "bank-item ta-c",
      attrs: {
        "clstag": item.clstag
      }
    }, [_c('a', {
      attrs: {
        "href": _vm.getBankUrl(item.url)
      }
    }, [_c('div', {
      staticClass: "bank-title"
    }, [_c('img', {
      staticClass: "bank-logo",
      attrs: {
        "src": item.productLogo
      }
    }), _c('span', {
      staticClass: "font-bold"
    }, [_vm._v(_vm._s(item.productName))])]), _vm._v(" "), _c('div', {
      staticClass: "bank-subtitle"
    }, [_vm._v(_vm._s(item.productLabel))]), _vm._v(" "), _c('div', {
      staticClass: "bank-range"
    }, [_c('span', [_vm._v("¥ ")]), _vm._v(_vm._s(_vm.replaceZh(item.availableAmount || item.amountRange)))]), _vm._v(" "), _c('div', {
      staticClass: "bank-rate"
    }, [_vm._v("综合费率(日) " + _vm._s(item.rate))])])]) : _vm._e()
  })), _vm._v(" "), (_vm.itemLength > 2) ? _c('div', {
    staticClass: "more-btn ta-c",
    on: {
      "click": _vm.changeAll
    }
  }, [(_vm.showAll) ? _c('span', [_vm._v("收起"), _c('span', {
    class: {
      flip: _vm.showAll, btnArrow: true
    }
  })]) : _c('span', [_vm._v("查看更多"), _c('span', {
    class: {
      flip: _vm.showAll, btnArrow: true
    }
  })])]) : _vm._e()]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h6', {
    staticClass: "lendMoney-title ta-c"
  }, [_c('span', [_vm._v("——")]), _vm._v(" 其他借款方式 "), _c('span', [_vm._v("——")])])
}]}

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gold-head"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "gold-sub-title ta-c"
  }, [_c('span', [_vm._v("—— ")]), _c('span', [_vm._v(_vm._s(_vm.goldStates.subTitle))]), _c('span', [_vm._v(" ——")])]), _vm._v(" "), _c('div', {
    staticClass: "gold-amount ta-c"
  }, [_c('span', {
    staticClass: "money-icon"
  }), _vm._v(_vm._s(_vm.goldAmount))]), _vm._v(" "), _c('div', {
    staticClass: "gold-slogen"
  }, [_c('h5', {
    staticClass: "ta-c"
  }, [_vm._v(_vm._s(_vm.goldStates.slogenText))]), _c('h6', {
    staticClass: "ta-c"
  }, [_vm._v("\n        " + _vm._s(_vm.goldStates.slogenSubText))])]), _vm._v(" "), _c('a', {
    staticClass: "gold-btn block",
    attrs: {
      "href": _vm.goldStates.btnHref,
      "clstag": "pageclick|keycount|jieqian|jintiao|url"
    }
  }, [_vm._v(_vm._s(_vm.goldStates.btnText))])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gold-logo ta-c"
  }, [_c('img', {
    staticClass: "h100",
    attrs: {
      "src": __webpack_require__(19)
    }
  })])
}]}

/***/ })
],[12]);


// WEBPACK FOOTER //
// static/js/app.86514e36ef331533a718.js